// extracted by mini-css-extract-plugin
export default {"fullscreen-container":"L0LLbo7qs2Fbc7Y5Kg5y"};